/* eslint-disable no-plusplus */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Divider } from '@material-ui/core';

import DataTable from '~/components/DataTable';
import LocaleMessage from '~/components/LocaleMessage';
import CounterCard from '~/components/Reports/CounterCard';
import ExportCSVButton from '~/components/Reports/CSVButton';
import ReportPieChart from '~/components/Reports/ReportPieChart';

import GetFileName from '~/util/GetFileName';

import { TotalContainer, RowArea, InfoContainer } from '../../style';
import Filter from './FilterData';

export default function CallInviteView({ settings, data, active, colors }) {
    const { format } = settings;
    const call_data = Filter(data, format);

    const [subTables, setSubTables] = useState({});

    const _headers = [
        {
            id: 'start',
            order_by: 'start_timestamp',
            label: <LocaleMessage msg="table.headers.invite_start" />,
        },
        {
            id: 'group_name',
            label: <LocaleMessage msg="table.headers.group" />,
        },
        {
            id: 'robot_name',
            label: <LocaleMessage msg="table.headers.robot" />,
        },
        {
            id: 'user_name',
            label: <LocaleMessage msg="table.headers.invited_by" />,
        },
        {
            id: 'duration_label',
            order_by: 'duration',
            label: <LocaleMessage msg="table.headers.invite_duration" />,
        },
        {
            id: 'accesses_length',
            label: <LocaleMessage msg="table.headers.accesses" />,
        },
    ];

    const headers_file = {
        main: [
            { key: 'group_name', label: 'Group' },
            { key: 'robot_name', label: 'Robot' },
            { key: 'application_name', label: 'Application' },
            {
                key: 'user_name',
                label: 'Invited By',
            },
            {
                key: 'start_date',
                label: 'Invite Start Date',
            },
            {
                key: 'start_time',
                label: 'Invite Start Time',
            },
            {
                key: 'duration_label',
                label: 'Invite Duration',
            },
            {
                key: 'accesses_length',
                label: 'Accesses',
            },
        ],
        sub: [
            { key: 'identification', label: 'Access Identification' },
            { key: 'start_date', label: 'Access Start Date' },
            { key: 'start_time', label: 'Access Start Time' },
            { key: 'end_date', label: 'Access End Date' },
            { key: 'end_time', label: 'Access End Time' },
            { key: 'duration_label', label: 'Access Call Duration' },
        ],
    };

    const headers_sub = [
        {
            id: 'identification',
            label: <LocaleMessage msg="table.headers.identification" />,
        },
        {
            id: 'start',
            order_by: 'start_timestamp',
            label: <LocaleMessage msg="table.headers.start_date" />,
        },
        {
            id: 'end',
            order_by: 'end_timestamp',
            label: <LocaleMessage msg="table.headers.end_date" />,
        },
        {
            id: 'duration_label',
            order_by: 'duration',
            label: <LocaleMessage msg="table.headers.duration" />,
        },
    ];

    const show_group_card = active && active.id === '*';
    const def_class = `col-md-4 col-12 mb-5`;

    const pie_charts = [
        ...(show_group_card
            ? [
                  {
                      key: 'groups',
                      title: 'per_group',
                      color: colors.dashboard_cards,
                      data: call_data.groups,
                  },
              ]
            : []),
        {
            key: 'robots',
            title: 'per_robot',
            color: colors.dashboard_graphs,
            data: call_data.robots,
        },
        {
            key: 'applications',
            title: 'per_application',
            color: colors.dashboard_cards,
            data: call_data.applications,
        },
        {
            key: 'users',
            title: 'per_user',
            color: colors.dashboard_graphs,
            data: call_data.users,
        },
    ];

    const total_calls = data ? data.length : 0;
    const call_list = call_data ? call_data.data : [];

    function onRowClick(event, _id) {
        const call = call_list.find(i => {
            return i.id === _id;
        });

        if (call) {
            const sub = subTables[_id]
                ? false
                : {
                      id: _id,
                      title: (
                          <LocaleMessage msg="page.reports.telepresence.label.mode.invite_accesses" />
                      ),
                      headers: headers_sub,
                      rows: call.accesses,
                  };

            setSubTables({
                ...subTables,
                [_id]: sub,
            });
        }
    }

    function getSubValues(list, subKey) {
        const full_list = [];

        const sub_headers = headers_file.sub || [];
        const sub_headers_file = sub_headers.map(h => {
            return {
                ...h,
                key: `${subKey}_${h.key}`,
            };
        });

        list.forEach(r => {
            full_list.push(r);

            const sub_list = r[subKey] || [];
            sub_list.forEach(v => {
                const sub_obj = {};
                sub_headers.forEach((k, i) => {
                    const sub_h = sub_headers[i] || {};
                    const file_h = sub_headers_file[i] || {};
                    sub_obj[file_h.key] = v[sub_h.key];
                });
                full_list.push(sub_obj);
            });
        });

        return {
            headers: [...headers_file.main, ...sub_headers_file],
            list: full_list,
        };
    }

    function renderCSVButton() {
        const full_list = getSubValues(call_list, 'accesses');
        return (
            <ExportCSVButton
                data={full_list.list}
                headers={full_list.headers}
                filename={GetFileName(
                    `REPORTS-telepresence_calls-invites`,
                    'csv'
                )}
            />
        );
    }

    return (
        <>
            <RowArea className="mt-5 mb-3">
                <div>
                    <p className="card-title">
                        <LocaleMessage msg="page.reports.telepresence.label.mode.invite" />
                    </p>
                </div>
            </RowArea>
            <TotalContainer className="row mt-3 mb-3">
                <CounterCard
                    classes="col-md-3 col-12"
                    title={
                        <LocaleMessage msg="page.reports.telepresence.label.total_calls" />
                    }
                    value={total_calls}
                />
                <CounterCard
                    classes="col-md-3 col-12"
                    title={
                        <LocaleMessage msg="page.reports.telepresence.label.total_duration" />
                    }
                    value={call_data.duration || '00:00:00'}
                />
                <CounterCard
                    classes="col-md-3 col-12"
                    title={
                        <LocaleMessage msg="page.reports.telepresence.label.mean_duration" />
                    }
                    value={call_data.mean_duration || '00:00:00'}
                />
            </TotalContainer>
            <Divider />
            <InfoContainer className="row mt-3 mb-3">
                {call_data ? (
                    <>
                        {pie_charts.map(c => {
                            const datakey = 'total';
                            return (
                                <ReportPieChart
                                    key={`${datakey}_${c.key}`}
                                    classes={def_class}
                                    title={
                                        <LocaleMessage
                                            msg={`page.reports.invites.label.${c.title}`}
                                        />
                                    }
                                    color={c.color}
                                    data={c.data}
                                    dataKey={datakey}
                                />
                            );
                        })}
                    </>
                ) : null}
            </InfoContainer>
            <Divider />
            <InfoContainer className="row mt-3 mb-3">
                <RowArea className="col-12 mb-3 table-responsive-material">
                    <div>
                        <p className="card-title">
                            <LocaleMessage msg="page.reports.telepresence.label.history" />
                        </p>
                    </div>
                    <DataTable
                        headerColumns={_headers}
                        data={call_list}
                        orderDirection="desc"
                        orderColumn="start_timestamp"
                        hasActions={false}
                        sortable
                        defaultRowsPerPage={25}
                        hasHeader
                        hasFilter
                        headerDirection="row-reverse"
                        header={
                            <div className="col-4" style={{ padding: '0px' }}>
                                {renderCSVButton()}
                            </div>
                        }
                        handleTableRowClick={(event, _id) =>
                            onRowClick(event, _id)
                        }
                        subTables={subTables}
                    />
                </RowArea>
            </InfoContainer>
        </>
    );
}

CallInviteView.defaultProps = {
    data: [],
    active: {},
};

CallInviteView.propTypes = {
    data: PropTypes.array,
    active: PropTypes.object,
    settings: PropTypes.object.isRequired,
    colors: PropTypes.object.isRequired,
};
